export const validationForConsignmentNoteNo = (value) => {
    const currentYear = new Date().getFullYear();
    const currentYearShort = currentYear.toString().slice(-2);
    const nextYearShort = (currentYear + 1).toString().slice(-2);
    const prevYearShort = (currentYear - 1).toString().slice(-2); // Support previous year formats
    const regex = new RegExp(`^IDP/(${prevYearShort}-${currentYearShort}|${currentYearShort}-${nextYearShort})/\\d{1,20}$`);
    return regex.test(value);
};

